<template>
    <div class="main-wrapper">
        <el-row type="flex" class="mb-1 align-center">
            <b class="section-subheader">Contact</b>
        </el-row>
        <el-row>
            <span>Control whether contact changes are sent to {{ integrationNameWithCasing }}, received from {{ integrationNameWithCasing }}, or both by selecting the appropriate direction.</span>
        </el-row>
        <el-row class="mt-1">
          <span><b>Best Practice</b>: {{ staticName }} and {{ integrationNameWithCasing }} <b>can both update</b> contacts (<i class="fas fa-arrows-alt-h"></i>) information, but {{ staticName }} <b>can not create</b> existing contact (<i class="fas fa-arrow-left"></i>) in {{ integrationNameWithCasing }}.</span>
        </el-row>

        <el-row :gutter="20" class="mt-3">
            <!-- Start Aloware and HubSpot Labels -->
            <el-col :span="10" class="mb-1">
                <small>{{ staticName }}</small>
            </el-col>
            <el-col :span="4" class="mb-1 text-center">
                <small>Direction</small>
            </el-col>
            <el-col :span="10" class="mb-1">
                <small>{{ integrationNameWithCasing }}</small>
            </el-col>
            <!-- End Aloware and HubSpot Labels -->
        </el-row>

      <el-row :gutter="20" type="flex" align="middle" class="mb-3">
        <!-- Start Aloware Fields -->
        <el-col :span="10">
          <el-input
              readonly
              value="Contact Creation"
              class="w-100"
          />
        </el-col>
        <!-- End Aloware Fields -->

        <el-col :span="4" class="text-center">
          <direction-boolean-selector
              :value="model.settings.filters.filter_never_create_new_contact_v2"
              @input="direction => updateDirection('filter_never_create_new_contact_v2', direction)"
          >
          </direction-boolean-selector>
        </el-col>

        <!-- Start CRM Fields -->
        <el-col :span="10">
          <el-input
              readonly
              value="Contact Creation"
              class="w-100"
          />
        </el-col>
        <!-- End CRM Fields -->
      </el-row>

      <el-row :gutter="20" type="flex" align="middle" class="mb-3">
        <!-- Start Aloware Fields -->
        <el-col :span="10">
          <el-input
              readonly
              value="Contact Update"
              class="w-100"
          />
        </el-col>
        <!-- End Aloware Fields -->

        <el-col :span="4" class="text-center">
          <direction-boolean-selector
              :value="model.settings.filters.filter_never_update_contact_guesty"
              @input="direction => updateDirection('filter_never_update_contact_guesty', direction)"
          >
          </direction-boolean-selector>
        </el-col>

        <!-- Start CRM Fields -->
        <el-col :span="10">
          <el-input
              readonly
              value="Contact Update"
              class="w-100"
          />
        </el-col>
        <!-- End CRM Fields -->
      </el-row>
    </div>
</template>

<script>
import DirectionBooleanSelector from "../direction-boolean-selector.vue";

export default {
    components: {
      DirectionBooleanSelector,
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        integrationNameWithCasing: {
            type: String,
            required: true
        },
        staticName: {
            type: String,
            required: true
        }
    },
  created() {
    // Initialize filters if it doesn't exist
    if (!this.model.settings.filters) {
      this.$set(this.model.settings, 'filters', {});
    }
    
    // Initialize filter properties to make them reactive
    if (!this.model.settings.filters.hasOwnProperty('filter_never_create_new_contact_v2')) {
      // Add fallback compatibility
      if (this.model.settings.filters.hasOwnProperty('filter_never_create_new_contact')) {
        this.$set(this.model.settings.filters, 'filter_never_create_new_contact_v2', this.model.settings.filters.filter_never_create_new_contact);
      } else {
        this.$set(this.model.settings.filters, 'filter_never_create_new_contact_v2', this.model.settings.filters?.filter_never_update_contact !== undefined);
      }
    }
    
    if (!this.model.settings.filters.hasOwnProperty('filter_never_update_contact_guesty')) {
      this.$set(this.model.settings.filters, 'filter_never_update_contact_guesty', false);
    }
  },
  mounted() {
    // Listen for reset-tab events from root
    this.$root.$on('integration-settings-reset-tab', this.handleResetTab)
  },
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('integration-settings-reset-tab', this.handleResetTab)
  },
  methods: {
        updateDirection(index, direction) {
            this.model.settings.filters[index] = direction
        },
        handleResetTab() {
          this.model.settings.filters.filter_never_create_new_contact = false
          this.model.settings.filters.filter_never_create_new_contact_v2 = true
          this.model.settings.filters.filter_never_update_contact_guesty = false

          // Show success notification
          this.$notify({
            title: `${this.integrationNameWithCasing} Integration`,
            message: 'The Synchronization tab has been reset to default values',
            type: 'success'
          })
        }
    },
}
</script>

<style scoped>
.main-wrapper {
    width: 100%;
}

.section-subheader {
    font-size: 16px;
}

.w-100 {
    width: 100%;
}

.align-center {
    align-items: center;
}
</style>
